export default {"src":"/_next/static/media/watch-moderate.7275a7ef.svg","height":73,"width":62};